export enum PostageType {
  FAST = "FAST",
  ECONOMIC = "ECONOMIC",
  URGENT = "URGENT",
}
